<app-content-shell [resizablePanel]="true">

  <app-header mainHeader />

  <app-panel-header panelHeader [title]="'Results'">
    @if (canSelectResults) {
      <div action class="action-btn" matTooltip="Delete selected" (click)="openDeleteMultipleModal()">
        <span class="material-icons action-btn__icon" translate="no">delete</span>
      </div>
    }
    <div
      action
      class="action-btn"
      [class.active]="canSelectResults"
      matTooltip="Select all"
      (click)="toggleSelectAll()"
    >
      <span class="material-icons action-btn__icon" translate="no">select_all</span>
    </div>
  </app-panel-header>

  <app-panel-tabs
    panelTabs
    [tabs]="groupTabs"
    [(active)]="activeGroupTab"
    (activeChange)="onGroupTabChange($event)"
  />

  @if (selectedOption === 'byBot') {
    <div panelSearch>
      <app-panel-search [(query)]="searchQuery" placeholder="Search bots..." />
    </div>
  }

  <div panelContent>
    @if (resultDataLoaderService.isLoading() && resultDataLoaderService.groupedResults().length === 0) {
      <mat-progress-spinner class="spinner" color="accent" mode="indeterminate" />
    } @else {
      <app-results-list
        (multipleItemsSelected)="multipleItemsSelectedHandler($event)"
        [canSelect]="canSelectResults"
        [groupedResults]="filteredGroupedResults"
        [selectedOption]="selectedOption"
        (itemSelected)="setSelectedItem($event)"
        (itemDeleted)="onConversationDeleted($event)"
      />
    }
  </div>

  <div mainContent class="results-main-content full-height-content">
    @if (!selectedItem) {
      <app-empty-state
        icon="forum"
        title="Select a conversation"
        subtitle="Choose a conversation from the list to view its details."
      >
        @if (loadingLatest) {
          <mat-progress-spinner class="results-empty-state__spinner" color="accent" [diameter]="32" mode="indeterminate" />
        } @else if (latestConversations.length > 0) {
          <div class="results-empty-state__grid-wrap">
            <div class="results-empty-state__grid" role="list">
              @for (item of latestConversations; track item._id) {
                <button type="button" class="results-empty-state__card" (click)="setSelectedItem(item)">
                  <span class="results-empty-state__card-name" [title]="item.name">{{ item.name || 'New chat' }}</span>
                  @if (item.date) {
                    <span class="results-empty-state__card-date">{{ item.date | conversationRelativeDate }}</span>
                  }
                </button>
              }
              <div class="results-empty-state__card results-empty-state__card--ghost" aria-hidden="true"></div>
              <div class="results-empty-state__card results-empty-state__card--ghost" aria-hidden="true"></div>
              <div class="results-empty-state__card results-empty-state__card--ghost" aria-hidden="true"></div>
            </div>
            <div class="results-empty-state__fade" aria-hidden="true"></div>
          </div>
        } @else {
          <p class="results-empty-state__none">No conversations yet. Start a chat from a bot to see results here.</p>
        }
      </app-empty-state>
    } @else {
      <div class="conversation-wrapper">
        @if (conversationHistoryLoading()) {
          <div class="results-main-loading results-main-loading--overlay" aria-busy="true">
            <mat-progress-spinner class="spinner" color="accent" mode="indeterminate" />
          </div>
        }
        <app-agent-conversation
          [talkingWith]="bot ?? null"
          [conversationId]="selectedItem._id"
          [inputDisabledReason]="botLookupLoading ? 'Checking whether this agent is still available...' : botUnavailableReason"
          (historyLoadingChange)="onConversationHistoryLoading($event)"
        >
          <div header>
            <app-talking-avatar />
            <app-talking-avatar-playlist />
          </div>
        </app-agent-conversation>
      </div>
    }
  </div>

</app-content-shell>
